import {
    flaggedGroupLabel,
    unflaggedGroupLabel,
    completedGroupLabel,
} from './getGroupHeaderForFlagStatus.locstring.json';
import loc from 'owa-localize';
import type GroupHeader from '../type/GroupHeader';
import type { TableView } from 'owa-mail-list-store';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';

/**
 * Get GroupHeader for row
 * @param rowKey item key for which we want to lookup Flagged group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForFlagStatus(
    rowKey: string,
    tableView: TableView
): GroupHeader {
    switch (MailRowDataPropertyGetter.getFlagStatus(rowKey, tableView)) {
        case 'Complete':
            return {
                headerText: () => loc(completedGroupLabel),
                headerId: 'Completed',
            };
        case 'Flagged':
            return {
                headerText: () => loc(flaggedGroupLabel),
                headerId: 'Flagged',
            };
        default:
            return {
                headerText: () => loc(unflaggedGroupLabel),
                headerId: 'Unflagged',
            };
    }
}
